import { OrgIdContext } from "../../store/orgId_context";
import classes from "./integrationStyles.module.scss"
import { useCallback, useContext, useEffect, useRef, useState } from 'react';

//https://dev1.e-invoices.online/app/2e62b70d-9878-11ec-90f9-9536f254aa7f?id=b332aec2-95ce-11ee-9108-ee67f6910206
const InvoiceDisplayIframe = ({invoiceId, onExecuteResponse, ...props})=>{
    const [keyState, setKeystate] = useState(0);
    const {isPublic, connectionKey, integrationDevice} = useContext(OrgIdContext);
    const [randId] = useState(Math.random().toString(36).substring(7));
    const iframeRef = useRef(null);

    useEffect(() => {
        setKeystate(keyState+1)
    }, [onExecuteResponse])

    /*useEffect(() => {
        setTimeout(() =>{
            console.log(iframeRef);
            console.log(integrationDevice);
            if (iframeRef.current && integrationDevice){
                console.log("firing");
                iframeRef.current.contentWindow.postMessage({action:"apikey", APIKey : integrationDevice}, "*");
                //iframeRef.current.contentWindow.postMessage({action:"refresh"}, "*");
                iframeRef.current.contentWindow.postMessage({action:"load", id :invoiceId}, "*");
            }
        },1000);
        
    }, [iframeRef, isPublic,integrationDevice, invoiceId]);*/
    /*let _invId=invoiceId
    const onMessage = (e) =>{
        console.log(e);
        console.log(_invId);
        console.log(invoiceId);
        if(e.data?.id === randId && e.data?.ready===false)return;

        if(e.data?.action==="ready" && e.data?.ready===true){
            iframeRef.current.contentWindow.postMessage({action:"apikey", APIKey : integrationDevice}, "*");
            iframeRef.current.contentWindow.postMessage({action:"load", id :invoiceId}, "*");
        }
    }*/

    

    useEffect(() =>{
        const onMsg = (e) =>{
            if(e.data?.id === randId && e.data?.ready===false)return;

            if(e.data?.action==="ready" && e.data?.ready===true){
                iframeRef.current.contentWindow.postMessage({action:"apikey", APIKey : integrationDevice}, "*");
                iframeRef.current.contentWindow.postMessage({action:"load", id :invoiceId}, "*");
            }
        };

        window.addEventListener('message', onMsg);
        return () => {
            window.removeEventListener('message', onMsg);
        };
    },[invoiceId]);

    const iframeLoad = () =>{
        if(!iframeRef.current) return;
        iframeRef.current.contentWindow.postMessage({action:"isReady", id : randId}, "*");
        //iframeRef.current.contentWindow.addEventListener("message")
    }

    /*useEffect(() =>{
        console.log(invoiceId)
        iframeLoad();
    },[invoiceId]);*/

    

//https://dev.dddinvoices.com/invoicevisual/?id=4d4de36f-b073-11ee-90e8-0050564db057
    return(<>
    <div className={`${classes["container-nolimit"]}`}>
        {invoiceId && <iframe
            key={keyState}
            //src={process.env.REACT_APP_ORIGIN ?  process.env.REACT_APP_ORIGIN+`/app/2e62b70d-9878-11ec-90f9-9536f254aa7f?id=${invoiceId}` : `/app/2e62b70d-9878-11ec-90f9-9536f254aa7f?id=${invoiceId}`}
            src={process.env.REACT_APP_ORIGIN ?  process.env.REACT_APP_ORIGIN+`/invoicevisual?id=${invoiceId}&manual=true` : `/invoicevisual?id=${invoiceId}&manual=true`}
            //src={process.env.REACT_APP_ORIGIN ?  process.env.REACT_APP_ORIGIN+`/invoicevisual` : `/invoicevisual`}
            title={`iframe-invoiceIframe`}
            width="100%"
            height="100%"
            ref={iframeRef}
            onLoad={iframeLoad}
        ></iframe>}
    </div>
    </>)
}

export default InvoiceDisplayIframe;